import { useEffect, useState } from 'react';

import usePreferredLocale from '@/hooks/usePreferredLocale';
import useTranslations from '@/i18n/useTranslations';
import Text from '@/shared-components/text/components/Text';
import { getCategoryDisplayName } from '@/utils/categoryTaxonomy';

import Artist from './components/Artist';
import Color from './components/Color';
import Emotion from './components/Emotion';
import FilterCategory from './components/FilterCategory';
import Gallery from './components/Gallery';
import Medium from './components/Medium';
import Price from './components/Price';
import Size from './components/Size';
import Theme from './components/Theme';

import './index.css';

export default function SearchFiltersContent({ query, setQuery, isMobile=false }) {
  const t = useTranslations('common.shared.search.filters');
  const locale = usePreferredLocale();
  const [isLEActive, setIsLEActive] = useState(false);
  
  const onToggleLimitedEditions = () => {
    setIsLEActive(!isLEActive);
    setQuery({ ...query, limitedEditions: !isLEActive });
  };

  useEffect(() => {
    setIsLEActive(query.limitedEditions);
  }, [query.limitedEditions]);

  return (
    <>
      <div className="search-filters-content">
        <FilterCategory 
          className="default-height-animation" 
          category={t('categories.artist')}
          hasItems={query.artist && query.artist.length > 0} 
          numberOfItems={query.artist?.length} isMobile={isMobile}
        >
          <Artist query={query} setQuery={setQuery}/>
        </FilterCategory>

        <FilterCategory 
          className="default-height-animation" 
          category={t('categories.gallery')}
          hasItems={query.gallery && query.gallery.length > 0} 
          numberOfItems={query.gallery?.length} 
          isMobile={isMobile}
        >
          <Gallery query={query} setQuery={setQuery}/>
        </FilterCategory>

        <Price 
          query={query} 
          setQuery={setQuery} 
          isMobile={isMobile}
        />

        <Size 
          query={query} 
          setQuery={setQuery} 
          isMobile={isMobile}
        />

        <FilterCategory 
          className="default-height-animation" 
          category={getCategoryDisplayName('theme', locale)}
          hasItems={query.theme && query.theme.length > 0} 
          numberOfItems={query.theme?.length} 
          isMobile={isMobile}
        >
          <Theme query={query} setQuery={setQuery}/>
        </FilterCategory>

        <FilterCategory 
          className="default-height-animation" 
          category={getCategoryDisplayName('emotion', locale)}
          hasItems={query.emotion && query.emotion.length > 0} 
          numberOfItems={query.emotion?.length} 
          isMobile={isMobile}
        >
          <Emotion query={query} setQuery={setQuery}/>
        </FilterCategory>

        <FilterCategory 
          className="default-height-animation" 
          category={getCategoryDisplayName('medium', locale)}
          hasItems={query.medium && query.medium.length > 0} 
          numberOfItems={query.medium?.length} 
          isMobile={isMobile}
        >
          <Medium query={query} setQuery={setQuery}/>
        </FilterCategory>

        <FilterCategory 
          className="default-height-animation" 
          category={getCategoryDisplayName('color', locale)}
          hasItems={query.color && query.color.length > 0} 
          numberOfItems={query.color?.length} 
          isMobile={isMobile}
        >
          <Color query={query} setQuery={setQuery}/>
        </FilterCategory>
        <div className="search-filters-category-item__container" onClick={onToggleLimitedEditions}>
          <div className={`search-filters-category-item__select-display ${isLEActive ? "active" : ""}`}/>
          <Text className="search-filters-category-item__display-text dots-on-overflow" >
            {t('limited_editions')}
          </Text>
        </div>
      </div>
    </>
  );
}
